import { render, staticRenderFns } from "./ReconnectBlocker.vue?vue&type=template&id=0c4a7fb9&scoped=true&lang=pug&"
import script from "./ReconnectBlocker.vue?vue&type=script&lang=js&"
export * from "./ReconnectBlocker.vue?vue&type=script&lang=js&"
import style0 from "./ReconnectBlocker.vue?vue&type=style&index=0&id=0c4a7fb9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4a7fb9",
  null
  
)

export default component.exports